import { Conduit } from '@campingvision/conduit';
import { authentication } from '../interceptors/request';

const conduit = new Conduit(
  `${process.env.TWENTY_API_URL}products/itinerary/`,
  [],
  [authentication],
  [],
  false,
  30000,
  true,
);

export default {
  /**
   * @returns {AxiosPromise}
   */
  getProductTypes() {
    return conduit.get('twenty/product-types');
  },

  /**
   * @returns {AxiosPromise}
   */
  getItineraries() {
    return conduit.get('');
  },

  /**
   * @param itineraryId
   * @returns {AxiosPromise}
   */
  getItinerary(itineraryId) {
    return conduit.get(`${itineraryId}`);
  },

  /**
   * @param payload
   * @returns {AxiosPromise}
   */
  createItinerary(payload) {
    return conduit.post('add', payload);
  },

  /**
   * @param itineraryId
   * @param name
   * @param isExtension
   * @param difficultyLevel
   * @returns {AxiosPromise}
   */
  updateItinerary(payload) {
    return conduit.put(`${payload.id}/update`, payload);
  },

  /**
   * @returns {AxiosPromise}
   */
  getCountriesByProductTypeId(productTypeId) {
    return conduit.get(`countries/master?productTypeId=${productTypeId}`);
  },

  /**
   * @returns {AxiosPromise}
   */
  getCountriesWithAreasByProductTypeId(productTypeId) {
    return conduit.get(`countries/master/with-areas?productTypeId=${productTypeId}`);
  },

  /**
   * @param itineraryId
   * @returns {AxiosPromise}
   */
  getItinerarySalesCountries(itineraryId) {
    return conduit.get(`${itineraryId}/sales-countries`);
  },

  /**
   * @param itineraryId
   * @param countryIds
   * @returns {AxiosPromise}
   */
  updateItinerarySalesCountries(itineraryId, countryIds) {
    return conduit.post(`${itineraryId}/sales-countries/update`, {
      countryIds,
    });
  },

  /**
   * @param itineraryId
   * @returns {AxiosPromise}
   */
  getItineraryTripThemes(itineraryId) {
    return conduit.get(`${itineraryId}/trip-themes`);
  },

  /**
   * @param itineraryId
   * @param contentIds
   * @returns {AxiosPromise}
   */
  updateItineraryTripThemes(itineraryId, contentIds) {
    return conduit.put(`${itineraryId}/trip-themes/update`, {
      contentIds,
    });
  },

  /**
   * @param itineraryId
   * @returns {AxiosPromise}
   */
  getDayProgram(itineraryId) {
    return conduit.get(`${itineraryId}/day-program`);
  },

  /**
   * @param itineraryId
   * @returns {AxiosPromise}
   */
  addDayProgramEntry(itineraryId) {
    return conduit.post(`${itineraryId}/day-program/add`, {});
  },

  /**
   * @param payload
   * @returns {AxiosPromise}
   */
  deleteDayProgramEntry(payload) {
    const itineraryId = payload.itineraryId;
    const dayProgramId = payload.dayProgramId;
    return conduit.delete(`${itineraryId}/day-program/${dayProgramId}/delete`);
  },

  /**
   * @param payload
   * @returns {AxiosPromise}
   */
  updateDayProgram(payload) {
    const itineraryId = payload.itineraryId;
    const data = payload.data;
    return conduit.put(`${itineraryId}/day-program/update`, {
      dayProgramEntries: data,
    });
  },

  /**
   * @param payload
   * @returns {AxiosPromise}
   */
  updateDayProgramLocation(payload) {
    const itineraryId = payload.itineraryId;
    const data = payload.data;
    return conduit.put(`${itineraryId}/day-program/location/update`, {
      dayProgramId: data.dayProgramId,
      countryId: data.countryId,
      areaId: data.areaId,
    });
  },

  /**
   * @param itineraryId
   * @param dayProgramId
   * @returns {AxiosPromise}
   */
  getDayProgramHotels(itineraryId, dayProgramId) {
    return conduit.get(`${itineraryId}/day-program/${dayProgramId}/hotels`);
  },

  /**
   * @param itineraryId
   * @param dayProgramId
   * @param siteIds
   * @returns {AxiosPromise}
   */
  updateDayProgramHotels(itineraryId, dayProgramId, siteIds) {
    return conduit.put(`${itineraryId}/day-program/${dayProgramId}/hotels/update`, {
      siteIds,
    });
  },

  /**
   * @param itineraryId
   * @param dayProgramId
   * @returns {AxiosPromise}
   */
  getDayProgramExcursions(itineraryId, dayProgramId) {
    return conduit.get(`${itineraryId}/day-program/${dayProgramId}/excursions`);
  },

  /**
   * @param itineraryId
   * @param dayProgramId
   * @param mappings
   * @returns {AxiosPromise}
   */
  updateDayProgramExcursions(itineraryId, dayProgramId, extras) {
    return conduit.put(`${itineraryId}/day-program/${dayProgramId}/excursions/update`, {
      mappings: extras,
    });
  },

  /**
   * @returns {AxiosPromise}
   */
  getMealPlanTypes() {
    return conduit.get('meal-plan-types');
  },

  /**
   * @param itineraryId
   * @param dayProgramId
   * @returns {AxiosPromise}
   */
  getDayProgramMealPlans(itineraryId, dayProgramId) {
    return conduit.get(`${itineraryId}/day-program/${dayProgramId}/meal-plans`);
  },

  /**
   * @param itineraryId
   * @param dayProgramId
   * @param mappings
   * @returns {AxiosPromise}
   */
  updateDayProgramMealPlans(itineraryId, dayProgramId, mappings) {
    return conduit.put(`${itineraryId}/day-program/${dayProgramId}/meal-plans/update`, {
      mappings,
    });
  },

  /**
   * @param itineraryId
   * @returns {AxiosPromise}
   */
  getItineraryDomains(itineraryId) {
    return conduit.get(`${itineraryId}/domains`);
  },

  /**
   * @param itineraryId
   * @param itineraryDomains
   * @returns {AxiosPromise}
   */
  addItineraryDomains(itineraryId, itineraryDomains) {
    return conduit.post(`${itineraryId}/domains/add`, {
      itineraryDomains,
    });
  },

  /**
   * @param itineraryId
   * @param itineraryDomains
   * @returns {AxiosPromise}
   */
  updateItineraryDomains(itineraryId, itineraryDomains) {
    return conduit.put(`${itineraryId}/domains/update`, {
      itineraryDomains,
    });
  },

  /**
   * @param itineraryId
   * @returns {AxiosPromise}
   */
  getSeoTeaserEntries(itineraryId) {
    return conduit.get(`${itineraryId}/teasers`);
  },

  /**
   * @param payload
   * @returns {AxiosPromise}
   */
  updateSeoTeaserEntry(payload) {
    const itineraryId = payload.itineraryId;
    const data = payload.data;
    return conduit.put(`${itineraryId}/teasers`, { itineraryTeasers: data });
  },

  /**
   * @param itineraryId
   * @param includeNot
   * @returns {AxiosPromise}
   */
  getIncludeEntries(itineraryId, includeNot) {
    const includeNotStr = includeNot ? '-not' : '';
    return conduit.get(`${itineraryId}/include${includeNotStr}`);
  },

  /**
   * @param payload
   * @param includeNot
   * @returns {AxiosPromise}
   */
  updateIncludeEntries(payload) {
    const { itineraryId, data } = payload;
    const includeNotStr = payload.includeNot ? '-not' : '';
    return conduit.put(`${itineraryId}/include${includeNotStr}`, { itineraryIncludes: data });
  },

  /**
   * @param itineraryId
   * @returns {AxiosPromise}
   */
  getIncludeCategories(itineraryId) {
    return conduit.get(`${itineraryId}/include/categories`);
  },

  /**
   * @param itineraryId
   * @param domainId
   * @param priceIntervals
   * @returns {AxiosPromise}
   */
  syncItineraryPriceIntervals(itineraryId, domainId, priceIntervals) {
    return conduit.post(`${itineraryId}/prices/by-domain-id/${domainId}/sync`, priceIntervals);
  },

  /**
   * @param itineraryId
   * @param domainId
   * @returns {AxiosPromise}
   */
  getItineraryPriceIntervals(itineraryId, domainId) {
    return conduit.get(`${itineraryId}/prices/by-domain-id/${domainId}/`);
  },

  /**
   * @param payload
   * @returns {AxiosPromise}
   */
  syncItineraryPriceSettings(payload) {
    return conduit.post(`price-intervals/${payload.priceIntervalId}/sync`, payload);
  },

  /**
   * @param priceIntervalId
   * @returns {AxiosPromise}
   */
  getItineraryPriceSettings(priceIntervalId) {
    return conduit.get(`/price-intervals/${priceIntervalId}/price-settings/with-day-program-allotments`);
  },

  /**
   * @param priceIntervalId
   * @returns {AxiosPromise}
   */
  copyItineraryPriceSettings(priceIntervalId) {
    return conduit.get(`/price-intervals/${priceIntervalId}/copy`);
  },

  /**
   * @param itineraryId
   * @returns {AxiosPromise}
   */
  cloneItinerary(itineraryId) {
    return conduit.get(`${itineraryId}/copy`);
  },
};



// WEBPACK FOOTER //
// ./src/services/itinerary-service.js